import image2 from "../img/raj-rana-ttzU0sZmkpA-unsplash.jpg"
import image3 from "../img/valentin-lacoste-Gzu0b_Ae2ck-unsplash.jpg"
import image5 from "../img/istockphoto-1154945979-612x612-1.jpg"
import image4 from "../img/Find_Swimming_Lessons_ASA-_learn_to_swim.jpg"
import Slider from "../slider/Slider"
import "./Cart.css"


export default function Cart(){
    return(
        <div>
            <div className="slid">
            <h1>خدمات آموزش شنا در تبریز</h1>
            </div>
       <div className="cards">
            <Slider image={image2} text="کلاس شنا کودکان دختر در تبریز"/>
            <Slider image={image3} text="کلاس شنا بزرگسالان درتبریز"/>
            <Slider image={image4} text="کلاس خصوصی شنا در تبریز"/>
            <Slider image={image5} text="کلاس نیمه خصوصی شنا در تبریز"/>
        </div>
        </div>
    )
}


